import React from 'react';
import styles from './Social2.module.css';

// Replace with your actual image paths
import asset1 from '../../../assets/safe2-asset-2.png' 
import asset2 from '../../../assets/safe2-asset-4.png';
import asset3 from '../../../assets/social2-asset-1.png';

const Social2 = () => {
  return (
    <section className={styles.social2Container}>
      <div className={styles.imageContainer}>
        <img src={asset1} alt="Asset 1" className={styles.assetLeft} />
        <img src={asset2} alt="Asset 2" className={styles.assetTop} />
        <img src={asset3} alt="Asset 3" className={styles.assetRight} />
      </div>

      <h2 className={styles.greenTitle}>Help build a safe, interactive community</h2>
    </section>
  );
};

export default Social2;
